<body>
  <div class="log-in-container">
    <div class="container px-4">
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <img class="img-fluid" src="assets/images/claro-certicamara-logos.png" alt="">
        </div>
        <div class="col-12 pb-3">
          <hr>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <h3 class="log-in-title">SISTEMA DE GESTIÓN ADMINISTRATIVO SIGA</h3>
        </div>
        <div class="col-12">
          <p class="alert-danger" *ngIf="failLogin">Correo electrónico y/o contraseña no válidos</p>
          <p class="alert-danger" *ngIf="errorLogin">Ocurrió un error y no se pudo iniciar sesión</p>
          <p class="alert-danger" *ngIf="sessionStarted">No puede iniciar sesión más de una vez</p>
          <form [formGroup]="loginForm" (ngSubmit)="save($event)">
            <mat-form-field class="w-100" appearance="legacy">
              <mat-label>Correo electrónico</mat-label>
              <input type="email" matInput id="email" formControlName="email" placeholder="Ej. juan@gmail.com">
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
            <p *ngIf="email.errors && email.touched" class="alert-danger">Debes ingresar un correo electrónico</p>
            <mat-form-field class="w-100" appearance="legacy">
              <mat-label>Contraseña</mat-label>
              <!--<input matInput formControlName="password" [type]="hide ? 'password' : 'text'">-->
              <input matInput formControlName="password" [type]="hide ? 'password' : 'text'">
              <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>
            <p *ngIf="password.errors && password.touched" class="alert-danger">Debes ingresar una contraseña</p>
            <!--<div class="col-12 pl-0">
              <a class="remind-password-txt" href="#">Recordar contraseña</a>
            </div>-->
            <div class="col-12 d-flex justify-content-center align-items-center my-3">
              <button type="submit" mat-raised-button color="primary" *ngIf="!loader">INICIAR SESIÓN</button>
              <span class="loader" *ngIf="loader"></span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</body>
